import { useState } from "react";
import axios from "axios";
import OrgAuthShell, { Champ, BoutonPrincipal } from "./OrgAuthShell";

const API = "https://api.komorotel.com/api";

/* Cette demande ne crée jamais un compte utilisable : le dossier est vérifié
   et la convention signée avant activation. C'est dit ici pour que personne
   n'attende de pouvoir réserver dans la foulée. */
export default function OrganizationRequest() {
  const [form, setForm] = useState({
    name: "", legalId: "", address: "", phone: "", email: "",
    managerFirstName: "", managerLastName: "", managerEmail: "", managerPhone: "",
  });
  const [loading, setLoading] = useState(false);
  const [envoye, setEnvoye]   = useState(false);
  const [erreur, setErreur]   = useState(null);

  const set = (k) => (v) => { setForm(s => ({ ...s, [k]: v })); setErreur(null); };

  const envoyer = async (e) => {
    e.preventDefault();
    setLoading(true);
    setErreur(null);
    try {
      await axios.post(`${API}/organization/request`, form);
      setEnvoye(true);
    } catch (err) {
      setErreur(err.response?.data?.message || "Une erreur est survenue.");
    } finally {
      setLoading(false);
    }
  };

  if (envoye) {
    return (
      <OrgAuthShell
        titre="Demande enregistrée"
        sousTitre="Nous vérifions votre dossier et revenons vers vous pour la convention. Vous recevrez ensuite un lien pour choisir votre mot de passe."
        pied={
          <a href="/" className="font-semibold text-[var(--k-green)] hover:underline">
            Retour à Komorotel
          </a>
        }
      >
        <span />
      </OrgAuthShell>
    );
  }

  return (
    <OrgAuthShell
      titre="Compte organisation"
      sousTitre="Pour les ONG, entreprises et administrations qui réservent des séjours aux Comores pour leurs équipes et les règlent elles-mêmes."
      pied={
        <>
          Vous avez déjà un compte ?{" "}
          <a href="/organisation/connexion" className="font-semibold text-[var(--k-green)] hover:underline">
            Se connecter
          </a>
        </>
      }
    >
      <form onSubmit={envoyer} className="flex flex-col gap-8">

        {erreur && (
          <p className="px-3.5 py-2.5 rounded-xl bg-red-50 border border-red-100 text-sm text-red-600">
            {erreur}
          </p>
        )}

        <div className="flex flex-col gap-4">
          <p className="text-[15px] font-semibold text-gray-900">L'organisation</p>
          <Champ label="Nom de l'organisation" value={form.name} onChange={set("name")} required />
          <Champ label="Numéro d'enregistrement" value={form.legalId} onChange={set("legalId")} />
          <Champ label="Adresse du siège" value={form.address} onChange={set("address")} />
          <Champ label="Téléphone" type="tel" value={form.phone} onChange={set("phone")} />
          <Champ label="Email général" type="email" value={form.email} onChange={set("email")} />
        </div>

        <div className="flex flex-col gap-4 pt-1" style={{ borderTop: "1px solid #f1f2f4" }}>
          <div className="pt-6">
            <p className="text-[15px] font-semibold text-gray-900">Le responsable</p>
            <p className="text-sm text-gray-500 mt-1">
              La personne qui gérera les membres et validera les réservations.
            </p>
          </div>
          <Champ label="Prénom" value={form.managerFirstName} onChange={set("managerFirstName")} required />
          <Champ label="Nom" value={form.managerLastName} onChange={set("managerLastName")} required />
          <Champ label="Email" type="email" value={form.managerEmail} onChange={set("managerEmail")} required />
          <Champ label="Téléphone" type="tel" value={form.managerPhone} onChange={set("managerPhone")} />
        </div>

        <div>
          <BoutonPrincipal type="submit" disabled={loading}>
            {loading ? "Envoi..." : "Envoyer la demande"}
          </BoutonPrincipal>
          <p className="text-xs text-gray-400 mt-3 leading-relaxed">
            Le compte est activé après vérification du dossier et signature de
            la convention. Aucune réservation n'est possible avant.
          </p>
        </div>
      </form>
    </OrgAuthShell>
  );
}
